<template>
  <div class="bread-crumbs-container">
    <UiBreadCrumb :crumbs="crumbs" />
  </div>
</template>

<script lang="ts" setup>
import UiBreadCrumb from '@sephora-asia/ui-bread-crumb'
import type { CategoryFilters } from '~/types/api/data/product/filter/filter.types'
import {
  capitalizeEachWord,
  removeDashOrUnderscore,
} from '~/utils/string-helpers'

const props = defineProps<{
  categoryFilters: CategoryFilters[]
  slugTitle: string
}>()

const { baseDirectory } = useBaseRoutes()
const { getCategoryPathFromRoute } = useProductListingRoutes()

const crumbs = computed(() => {
  const crumbArray = getInitialCrumbs()
  const categoryUrlMatcher: string[] = []

  getCategoryPathFromRoute()
    .split('/')
    .forEach((categoryUrl: string) => {
      categoryUrlMatcher.push(categoryUrl)

      const category = props.categoryFilters.find(
        (categoryFilter: CategoryFilters) =>
          categoryFilter.slugUrl === categoryUrlMatcher.join('/')
      )

      if (category) {
        crumbArray.push(constructCrumb(category.label, category.slugUrl))
      }
    })

  return crumbArray
})

function getInitialCrumbs() {
  const initialCrumbs = [
    {
      name: 'Home',
      path: '/',
    },
  ]
  if (props.slugTitle) {
    initialCrumbs.push(constructCrumb(props.slugTitle, ''))
  }
  return initialCrumbs
}

function constructCrumb(name: string, url: string) {
  const crumbPath = `/${[baseDirectory.value, url].filter(Boolean).join('/')}`
  return {
    name: capitalizeEachWord(removeDashOrUnderscore(name)),
    path: crumbPath,
  }
}
</script>
